import React, { useEffect } from 'react'
import { useParams } from 'react-router';

export default function AudioPlayer() {
    const param = useParams()

    const path = process.env.REACT_APP_STATIC_CDN_ASSETS_IUIU

    useEffect(()=>{
        console.log(param.id)
    }, [])
    return (
        <div className='row center' style={{marginTop: "5rem", height: "100vh"}}>
            <audio controls preload="none">
                {param && param.id.split(".")[1]==="m4a" ? 
                <source src={`${path}/${param.id}`} type="audio/mp4"/> :
                <source src={`${path}/${param.id}`} type={`audio/${param.id.split(".")[1]}`}/>}
                Your browser does not support the audio element.
            </audio>
        </div>
    )
}
